import { connect } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";

import React, { useEffect } from "react";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import ControlledButton from "components/UI/ControlledButton";
import { Add } from "@mui/icons-material";
import Modal from "components/Modal/Modal";
import Structure from "./Structure";
import MenuPermissions from "../MenuPermissions";
import TabPanel from "helpers/TabPanel";
import TabBoxComponent from "components/UI/TabBox";
import FormDialog from "helpers/FormDialog";

const StructureList = ({
  FetchDetails,
  SubmitGeneralForm,
  SetSelectedMenu,
  location,
  loggedUser,
}) => {
  // const subMenuCode = "submenu.menu";

  const [open, setOpen] = React.useState(0);
  const [tabValue, setTabValue] = React.useState(location?.state?.tab ?? 0);

  const [selectedStructure, setSelectedStructure] = React.useState();
  const [structures, setStructures] = React.useState([]);
  const [selectedType, setSelectedType] = React.useState("menu");
  const [menus, setMenus] = React.useState([]);
  const [foundMenu, setFoundMenu] = React.useState([]);
  const [select, setSelect] = React.useState(false);
  const [openSetting, setOpenSetting] = React.useState();
  const [subMenus, setSubMenus] = React.useState([]);
  const [actions, setActions] = React.useState([]);
  const [value, setValue] = React.useState({});

  const settings=selectedStructure?.StructureSetting

  const selectedList = selectedType === "action" ? actions : menus;

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const loadStructure = async () => {
    const response = await FetchDetails(`/api/structure/list`);
    if (response.status) {
      setStructures(response.data.data);
    }
  };

  const loadStructureMenu = async () => {
    const response = await FetchDetails(
      `/api/structure/structure/menu?structureId=${selectedStructure?.id}`
    );
    if (response.status) {
      setFoundMenu(response.data.data);
    }
  };

  const loadMenu = async () => {
    const { status, data } = await FetchDetails(`/api/structure/system/menu`);
    if (status) {
      setMenus(data?.data?.filter((menu) => menu?.type === "menu"));
      setSubMenus(data?.data?.filter((menu) => menu?.type === "subMenu"));
      setActions(
        data?.data?.filter(
          (menu) => menu?.type === "action" && menu?.parentId === null
        )
      );
    }
  };

  const onCheck = async (row) => {
    const resp = await SubmitGeneralForm(`/api/structure/menu/assign`, row);
    if (resp.status) {
      await loadStructureMenu();
    } 
  };

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  useEffect(() => {
    loadStructure().then();
    loadMenu().then();
  }, []);

  useEffect(() => {
    if (selectedStructure) {
      loadStructureMenu().then();
    }
  }, [selectedStructure]);

  return (
    <div className="w-full mb-12 px-4">
      {/* ==========================================system menus============================== */}

      <Modal
        maxWidth={"sm"}
        title={selectedType==="action"?"General Action List":"Menu List"}
        select={select}
        setSelect={setSelect}
      >
        <TableContainer className="border">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedList?.length ? (
                selectedList?.map((row, index) => {
                  const existMenu =
                    foundMenu.find((perm) => perm?.menuId === row.id) ?? {};
                  const menu = {
                    menuId: row.id,
                    structureId: selectedStructure?.id,
                    name: row.name,
                    order: row.order,
                    icon: row.icon,
                  };

                  return (
                    <TableRow>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row?.name}</TableCell>

                      <TableCell>
                        <Checkbox
                          checked={existMenu.menuId === row.id}
                          onChange={(event) => {
                            onCheck({
                              ...menu,
                              structureMenuId: existMenu?.id,
                            });
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="text-center">
                    No permission selected
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Modal>

      {/* ===============================================end system menu========================= */}

    
  
      {/* otherInfo: {
        type: DataTypes.TEXT,
      },
      websiteUrl: {
        type: DataTypes.STRING,
      }, */}


        <FormDialog
              maxWidth={"md"}
              col={6}
              open={openSetting > 0}
              onSuccess={() => {
                loadStructure();
              }}
              setOpen={setOpenSetting}
              url={`/api/structure/settings/create/${selectedStructure?.id}`}
              title={ `${selectedStructure?.name} settings`}
              fields={[
            
                {
                  name: "mainBackground",
                  label: "Main Background (Color code)",
                  value: value["mainBackground"]??settings?.mainBackground ,
                  required: true,
                  col: 12,
                  setValue: (val) => setValue0("mainBackground", val),
                },
            
                {
                  name: "backgroundSideBar",
                  label: "SideBar background (Color code)",
                  value: value["backgroundSideBar"]??settings?.backgroundSideBar,
                  col: 12,
                  setValue: (val) => setValue0("backgroundSideBar", val),
                },
                {
                  name: "backgroundNavBar",
                  label: "Navbar background (Color code)",
                  value: value["backgroundNavBar"]??settings?.backgroundNavBar,
                  col: 12,
                  setValue: (val) => setValue0("backgroundNavBar", val),
                },
                {
                  name: "headerStats",
                  label: "Header Stats(Color code) ",
                  value: value["headerStats"]??settings?.headerStats,
                  col: 12,
                  setValue: (val) => setValue0("headerStats", val),
                },
                {
                  name: "mainColor",
                  label: "main text Color (Color code)",
                  value: value["mainColor"]??settings?.mainColor,
                  col: 12,
                  setValue: (val) => setValue0("mainColor", val),
                },
                {
                  name: "logoImage",
                  label: "Logo Image",
                  type: "file-drag",
                  value: value["logoImage"]??settings?.logoImage,
                  col: 12,
                  setValue: (val) => setValue0("logoImage", val),
                },
            
                {
                  name: "reportLogoImage",
                  label: "Report Logo Image",
                  type: "file-drag",
                  value: value["reportLogoImage"]??settings?.reportLogoImage,
                  col: 12,
                  setValue: (val) => setValue0("reportLogoImage", val),
                },
                {
                  name: "favicon",
                  label: "Header Icon",
                  type: "file-drag",
                  multiple:true,
                  value: value["favicon"]??settings?.favicon,
                  col: 12,
                  setValue: (val) => setValue0("favicon", val),
                },
                {
                  name: "systemNameAbr",
                  label: "System Name Abr",
                  value: value["systemNameAbr"]??settings?.systemNameAbr,
                  col: 12,
                  setValue: (val) => setValue0("systemNameAbr", val),
                },
                {
                  name: "systemNameFull",
                  label: "System Name Full",
                  value: value["systemNameFull"]??settings?.systemNameFull,
                  col: 12,
                  setValue: (val) => setValue0("systemNameFull", val),
                },
                {
                  name: "websiteUrl",
                  label: "Website Url",
                  value: value["websiteUrl"]??settings?.websiteUrl,
                  col: 12,
                  setValue: (val) => setValue0("websiteUrl", val),
                },
                {
                  name: "otherInfo",
                  label: "Other Info",
                  value: value["otherInfo"]??settings?.otherInfo,
                  type:"textarea",
                  col: 12,
                  setValue: (val) => setValue0("otherInfo", val),
                }
              ]}
            />

      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabBoxComponent
            selectedValue={tabValue}
            handleTabChange={handleChange}
            tabList={[
              {
                label: "Menus",
                tabValue: 0,
              },
              {
                label: "Actions",
                tabValue: 1,
              },
              {
                label: "RMS Users",
                tabValue: 2,
              },
            ]}
          />

          <TabPanel index={0} value={tabValue} p={0}>
            <MenuPermissions
              location={location}
              SetSelectedMenu={SetSelectedMenu}
              category={"menu"}
              menus={menus}
              subMenus={subMenus}
              actions={actions}
            />
          </TabPanel>
          <TabPanel index={1} value={tabValue} p={0}>
            <MenuPermissions
              location={location}
              SetSelectedMenu={SetSelectedMenu}
              category={"action"}
              menus={menus}
              subMenus={subMenus}
              actions={actions}
            />
          </TabPanel>
          <TabPanel index={2} value={tabValue} p={0}>
            <Card className="flex flex-col w-full">
              <CardHeader
                title={"RMS Client Institutions"}
                action={
                  <ControlledButton
                    className="text-red-800"
                    variant="contained"
                    onClickAction={() => {
                      setOpen(1);
                    }}
                    label={"Add new"}
                    icon={<Add />}
                    // subMenuCode={subMenuCode}
                    // checkSubMenuPermission={true}
                    type="button"
                  />
                }
              />
              <CardContent>
                <Structure
                  structures={structures}
                  onSuccess={loadStructure}
                  setSelect={setSelect}
                  setSelectedStructure={setSelectedStructure}
                  loggedUser={loggedUser}
                  setSelectedType={setSelectedType}
                  open={open}
                  setOpen={setOpen}
                  loadStructure={loadStructure}
                  setOpenSetting={setOpenSetting}
                />
              </CardContent>
            </Card>
          </TabPanel>
        </Box>
      </Card>
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(StructureList);
